import cx from 'classnames';
import { Icon } from 'assets/icons';
import { TreeContext } from 'contexts/automation';
import { useAutomationStepService } from 'hooks/automation/steps';
import React, { useContext, useEffect, useState } from 'react';
import { Handle, Position } from 'reactflow';
import { serializeBranch } from './serializer';
import styles from './widget.module.css';

export const AutomationBranchWidget = (props) => {
  const { id: source_handle_id, isConnectable, data } = props;
  const { deleteStep } = useAutomationStepService();
  const { setWidgetToCreate, toggleStepModal } = useContext(TreeContext);

  const [metadata, setMetadata] = useState({});

  useEffect(() => {
    if (!data || !data.metadata) return;
    const { metadata } = data;
    setMetadata(metadata);
  }, [data]);

  const handleDelete = async (e) => {
    e.stopPropagation();
    await deleteStep(data.id);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    if (data.children.length > 0) return;
    setWidgetToCreate('branch');
    toggleStepModal({
      template_id: data.template_id,
      parents: data.parents || [],
      show: true,
      mode: 'edit',
      data
    });
  };

  return (
    <div className={styles.widget}>
      <Handle type="target" position={Position.Top} isConnectable={isConnectable} />
      <div className={cx(styles.wrapper, styles.blue)}>
        <div className={styles.content} onClick={handleEdit}>
          <span>{serializeBranch(metadata)}</span>
          <span className={styles.icon}>
            <Icon name="trash" onClick={handleDelete} />
          </span>
        </div>
      </div>
      <span id={styles.vertLine} />
      <span className={styles.addBtn}>
        <Icon
          name="add"
          onClick={() => {
            setWidgetToCreate(() => '');
            toggleStepModal({
              template_id: data.template_id,
              parents: [data.id],
              source: '-',
              show: true,
              source_widget: 'branch'
            });
          }}
        />
      </span>
      <Handle
        type="source"
        position={Position.Bottom}
        id={source_handle_id}
        isConnectable={isConnectable}
      />
    </div>
  );
};
